import { render } from "./Gamelist.vue?vue&type=template&id=338ee7e1"
import script from "./Gamelist.vue?vue&type=script&lang=js"
export * from "./Gamelist.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\hw-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__